import type { ReactNode } from 'react';
import { Button, Dialog, Portal, Text } from 'react-native-paper';

import { unisonColors } from '@/theme';

interface ConfirmDialogProps {
  readonly visible: boolean;
  readonly title: string;
  readonly body: string;
  readonly note?: ReactNode;
  readonly confirmLabel: string;
  readonly dismissLabel: string;
  readonly onConfirm: () => void;
  readonly onDismiss: () => void;
  readonly testID?: string;
}

export const ConfirmDialog = ({
  visible,
  title,
  body,
  note,
  confirmLabel,
  dismissLabel,
  onConfirm,
  onDismiss,
  testID,
}: ConfirmDialogProps) => {
  const hasBody = body !== '';
  const hasNote = note !== undefined && note !== null && note !== false;

  return (
    <Portal>
      <Dialog
        visible={visible}
        onDismiss={onDismiss}
        style={{ backgroundColor: unisonColors.white }}
        testID={testID}>
        <Dialog.Title>{title}</Dialog.Title>
        {hasBody || hasNote ? (
          <Dialog.Content style={{ paddingBottom: 0 }}>
            {hasBody ? <Text variant="bodyMedium">{body}</Text> : null}
            {hasBody && hasNote ? <Text variant="bodyMedium">{'\n'}</Text> : null}
            {hasNote ? note : null}
          </Dialog.Content>
        ) : null}
        <Dialog.Actions>
          <Button
            onPress={onDismiss}
            testID="confirm-dialog-dismiss"
            textColor={unisonColors.onInfoContainer}>
            {dismissLabel}
          </Button>
          <Button
            onPress={onConfirm}
            testID="confirm-dialog-confirm"
            textColor={unisonColors.onInfoContainer}>
            {confirmLabel}
          </Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
};
